import {
  MODULE_FILE_CSV_UPLOAD,
  MODULE_FILE_CSV_UPLOAD_SUCCESS,
  MODULE_FILE_CSV_UPLOAD_ERROR,
  MODULE_AVAILABLE_MODULE_FIELDS,
  MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS,
  MODULE_AVAILABLE_MODULE_FIELDS_ERROR,
  FILE_ATTACHMENT_CREATE_PREAUTH,
  FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS,
  FILE_ATTACHMENT_CREATE_PREAUTH_ERROR,
} from "./actionType";

export const moduleFileCsvUpload = (data) => {
  return {
    type: MODULE_FILE_CSV_UPLOAD,
    payload: data,
  };
};

export const moduleFileCsvUploadSuccess = (data) => {
  return {
    type: MODULE_FILE_CSV_UPLOAD_SUCCESS,
    payload: data,
  };
};

export const moduleFileCsvUploadError = (data) => {
  return {
    type: MODULE_FILE_CSV_UPLOAD_ERROR,
    payload: data,
  };
};

export const moduleAvailableModuleFields = () => {
  return {
    type: MODULE_AVAILABLE_MODULE_FIELDS,
  };
};
export const moduleAvailableModuleFieldsSuccess = (data) => {
  return {
    type: MODULE_AVAILABLE_MODULE_FIELDS_SUCCESS,
    payload: data,
  };
};
export const moduleAvailableModuleFieldsError = (data) => {
  return {
    type: MODULE_AVAILABLE_MODULE_FIELDS_ERROR,
    payload: data,
  };
};

export const fileAttachmentCreatePreauth = (data) => {
  return {
    type: FILE_ATTACHMENT_CREATE_PREAUTH,
    payload: data,
  };
};

export const fileAttachmentCreatePreauthSuccess = (data) => {
  return {
    type: FILE_ATTACHMENT_CREATE_PREAUTH_SUCCESS,
    payload: data,
  };
};

export const fileAttachmentCreatePreauthError = (error) => {
  return {
    type: FILE_ATTACHMENT_CREATE_PREAUTH_ERROR,
    payload: error,
  };
};
